// Enhanced logging utility with configurable log levels
const isDevelopment = import.meta.env.DEV
const isProduction = import.meta.env.PROD

// Log configuration - set to false to disable specific log categories
const LOG_CONFIG = {
  // Core application logs
  mobileDebug: isDevelopment && false, // Disable mobile debug logs
  app: isDevelopment && false, // Disable app component logs
  
  // API and data logs
  api: isDevelopment && false, // Disable API logs
  supabaseApi: isDevelopment && false, // Disable Supabase API logs
  utilities: isDevelopment && false, // Disable utilities logs
  data: isDevelopment && false, // Disable data logs
  
  // Auth and system logs
  auth: isDevelopment && false, // Disable auth logs to reduce noise
  sw: isDevelopment && false, // Disable service worker logs to reduce noise
  
  // Error and warning logs (always enabled)
  error: true,
  warn: true,
  
  // Performance and monitoring
  performance: isDevelopment && false, // Disable performance logs
  cache: isDevelopment && false, // Disable cache logs
  
  // New categories for specific log sources
  reactQuery: isDevelopment && false, // Disable React Query logs completely
  companyBranding: isDevelopment && false, // Disable company branding logs
  customTerms: isDevelopment && false, // Disable custom terms logs
  communication: isDevelopment && false, // Disable communication logs
  packages: isDevelopment && false, // Disable packages logs
  expenseManagement: isDevelopment && false, // Disable expense management logs
}

// Helper function to check if a log category is enabled
const isLogEnabled = (category) => {
  return LOG_CONFIG[category] === true
}

export const logger = {
  // Always log errors and warnings
  error: console.error.bind(console),
  warn: console.warn.bind(console),
  
  // Conditional logging based on configuration
  info: (message, ...args) => {
    if (isLogEnabled('data')) console.log(`[Info] ${message}`, ...args)
  },
  
  debug: (message, ...args) => {
    if (isLogEnabled('data')) console.log(`[Debug] ${message}`, ...args)
  },
  
  // Categorized logging
  mobileDebug: (message, ...args) => {
    if (isLogEnabled('mobileDebug')) console.log(`[Mobile Debug] ${message}`, ...args)
  },
  
  app: (message, ...args) => {
    if (isLogEnabled('app')) console.log(`[App] ${message}`, ...args)
  },
  
  api: (message, ...args) => {
    if (isLogEnabled('api')) console.log(`[API] ${message}`, ...args)
  },
  
  supabaseApi: (message, ...args) => {
    if (isLogEnabled('supabaseApi')) console.log(`[supabaseApi] ${message}`, ...args)
  },
  
  utilities: (message, ...args) => {
    if (isLogEnabled('utilities')) console.log(`[utilities] ${message}`, ...args)
  },
  
  auth: (message, ...args) => {
    if (isLogEnabled('auth')) console.log(`[Auth] ${message}`, ...args)
  },
  
  data: (message, ...args) => {
    if (isLogEnabled('data')) console.log(`[Data] ${message}`, ...args)
  },
  
  cache: (message, ...args) => {
    if (isLogEnabled('cache')) console.log(`[Cache] ${message}`, ...args)
  },
  
  sw: (message, ...args) => {
    if (isLogEnabled('sw')) console.log(`[SW] ${message}`, ...args)
  },
  
  performance: (message, ...args) => {
    if (isLogEnabled('performance')) console.log(`[Performance] ${message}`, ...args)
  },
  
  // New categorized logging methods
  reactQuery: (message, ...args) => {
    if (isLogEnabled('reactQuery')) console.log(`[useReactQueryData] ${message}`, ...args)
  },
  
  companyBranding: (message, ...args) => {
    if (isLogEnabled('companyBranding')) console.log(`[companyBranding] ${message}`, ...args)
  },
  
  customTerms: (message, ...args) => {
    if (isLogEnabled('customTerms')) console.log(`[customTerms] ${message}`, ...args)
  },
  
  communication: (message, ...args) => {
    if (isLogEnabled('communication')) console.log(`[communication] ${message}`, ...args)
  },
  
  packages: (message, ...args) => {
    if (isLogEnabled('packages')) console.log(`[packages] ${message}`, ...args)
  },
  
  expenseManagement: (message, ...args) => {
    if (isLogEnabled('expenseManagement')) console.log(`[expenseManagement] ${message}`, ...args)
  },
  
}

export default logger
